import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export default function PollSwitch({label, handleChange}) {
  return <>
    <FormGroup>
      <FormControlLabel control={<Checkbox onChange={(event, checked) => {
        if (handleChange) {
          handleChange(checked)
        }
      }
      }/>} label={<>
        {label}
        <Tooltip title={<>{label} tooltip help</>} enterTouchDelay={0} leaveTouchDelay={5000}>
          <IconButton>
            <HelpIcon/>
          </IconButton>
        </Tooltip>
      </>} labelPlacement="end"/>
    </FormGroup>
  </>
}
